{
  "ChangeMenuTitle": "Rapport wijzigen",
  "UnknownReport": "[Onbekend rapport]",
  "NoSuitableReportsAvailable": "Geen geschikte rapporten beschikbaar.",
  "DashboardChangeFolderEmpty": "Behandel dit bericht door deze stappen te volgen:",
  "DashboardList_SectionHeader": "Lijst",
  "DashboardList_Add": "Toevoegen",
  "DashboardList_AddMenuTitle": "Toevoegen verwijderen",
  "DashboardList_MoveUp": "Omhoog gaan",
  "DashboardList_MoveDown": "Naar beneden verplaatsen",
  "DashboardList_Remove": "Verwijderen",
  "DashboardList_RemoveAll": "Verwijder alles",
  "DashboardList_RemoveAllConfirmMessage": "Weet u zeker dat u alle rapporten wilt verwijderen?",
  "NAME": "DashboardList"
}